export const Gilroy = "Gilroy-Bold";
export const Eczar = { regular: "Eczar-Regular", semiBold: "Eczar-SemiBold" };

export const normalText = {
  fontSize: "12px",
  fontFamily: Gilroy,
};
